import { SelectItem, NetworkSelectItem } from "@/types/select-list";
import { Account } from "@/types/account";
import { Network } from "@/types/network";
import { Validator } from "@/types/staking";
import { CrowdloanInfo } from "@/types/crowdloan";
import { dot } from "./tokens";

export const selectConnect: SelectItem = {
  id: 1,
  name: "Connected",
  image: require("@/assets/pic/app-pic.png"),
};

export const selectConnectItems: SelectItem[] = [
  {
    id: 1,
    name: "Connected",
    image: require("@/assets/pic/app-pic.png"),
  },
  {
    id: 2,
    name: "Disconnect",
  },
];

export const selectNetwork: NetworkSelectItem = {
  id: Network.Polkadot,
  name: "Polkadot",
  image: require("@/assets/pic/polkadot.network.png"),
};

export const selectNetworkItems: NetworkSelectItem[] = [
  {
    id: Network.Polkadot,
    name: "Polkadot",
    image: require("@/assets/pic/polkadot.network.png"),
  },
  {
    id: Network.Kusama,
    name: "Kusama",
    image: require("@/assets/pic/kusama.network.png"),
  },
];

export const accounts: Account[] = [
  {
    id: 1,
    name: "Account #1",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    isLedger: false,
  },
  {
    id: 2,
    name: "Main account",
    image: require("@/assets/pic/account2.png"),
    address: "1qnJN7FViy3HZaxZK9tGAA71zxHSBeUweirKqCaox4t8GT7",
    isLedger: true,
  },
  {
    id: 3,
    name: "My account nickname",
    image: require("@/assets/pic/account2.png"),
    address: "1qnJN7FViy3HZaxZK9tGAA71zxHSBeUweirKqCaox4t8GT7",
    isLedger: true,
  },
];

export const recent: Account[] = [
  {
    id: 1,
    name: "Alex",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    isLedger: false,
  },
  {
    id: 2,
    name: "",
    image: require("@/assets/pic/account2.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    isLedger: true,
  },
  {
    id: 3,
    name: "Ledger",
    image: require("@/assets/pic/account1.png"),
    address: "1c8vCnfzHCjZRUTYsFQF53nzPsW6yHd8vJPnmMXocPCtvvp",
    isLedger: true,
  },
  {
    id: 4,
    name: "",
    image: require("@/assets/pic/account2.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    isLedger: true,
  },
  {
    id: 5,
    name: "",
    image: require("@/assets/pic/account1.png"),
    address: "1c8vCnfzHCjZRUTYsFQF53nzPsW6yHd8vJPnmMXocPCtvvp",
    isLedger: true,
  },
];

export const validators: Validator[] = [
  {
    id: 1,
    name: "",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 0,
    total: 2099089,
    returns: 999999999.08,
    token: dot,
    isHighRisk: true,
    isOversubscribed: false,
  },
  {
    id: 2,
    name: "P2P.ORG/10",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 3,
    total: 2099089,
    returns: 139.08,
    token: dot,
    isHighRisk: false,
    isOversubscribed: false,
  },
  {
    id: 3,
    name: "Blockdaemon/5",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 289,
    commission: 5,
    total: 2099089,
    returns: 127.33,
    token: dot,
    isHighRisk: false,
    isOversubscribed: true,
  },
  {
    id: 4,
    name: "",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 0,
    total: 2099089,
    returns: 999999999.08,
    token: dot,
    isHighRisk: true,
    isOversubscribed: false,
  },
  {
    id: 5,
    name: "P2P.ORG/10",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 3,
    total: 2099089,
    returns: 139.08,
    token: dot,
    isHighRisk: true,
    isOversubscribed: false,
  },
  {
    id: 6,
    name: "Blockdaemon/5",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 289,
    commission: 5,
    total: 2099089,
    returns: 127.33,
    token: dot,
    isHighRisk: false,
    isOversubscribed: true,
  },
  {
    id: 7,
    name: "",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 0,
    total: 2099089,
    returns: 999999999.08,
    token: dot,
    isHighRisk: false,
    isOversubscribed: false,
  },
  {
    id: 8,
    name: "P2P.ORG/10",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 3,
    total: 2099089,
    returns: 139.08,
    token: dot,
    isHighRisk: false,
    isOversubscribed: false,
  },
  {
    id: 9,
    name: "Blockdaemon/5",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 289,
    commission: 5,
    total: 2099089,
    returns: 127.33,
    token: dot,
    isHighRisk: false,
    isOversubscribed: true,
  },
  {
    id: 10,
    name: "P2P.ORG/10",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 3,
    total: 2099089,
    returns: 139.08,
    token: dot,
    isHighRisk: false,
    isOversubscribed: false,
  },
];

export const selectValidators: Validator[] = [
  {
    id: 1,
    name: "P2P.ORG/10",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 0,
    total: 2099089,
    returns: 576.08,
    token: dot,
    isHighRisk: true,
    isOversubscribed: false,
  },
  {
    id: 2,
    name: "ZKValidator 1",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 36,
    commission: 3,
    total: 2099089,
    returns: 139.08,
    token: dot,
    isHighRisk: false,
    isOversubscribed: false,
  },
  {
    id: 3,
    name: "Zug Capital/02",
    image: require("@/assets/pic/account1.png"),
    address: "15pSLMoW287q4jYKBRsKr6bydqwR8xrZpAmxGFyUZBB4m73P",
    nominators: 289,
    commission: 5,
    total: 2099089,
    returns: 127.33,
    token: dot,
    isHighRisk: false,
    isOversubscribed: true,
  },
];

export const ongoing: CrowdloanInfo[] = [
  {
    key: "1",
    paraId: 1,
    name: "Kapex",
    link: "https://kapex.com",
    image: require("@/assets/pic/kapex.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: true,
  },
];

export const completed: CrowdloanInfo[] = [
  {
    key: "1",
    paraId: 1,
    name: "Bitfrost",
    link: "",
    image: require("@/assets/pic/bitfrost.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: false,
  },
  {
    key: "2",
    paraId: 1,
    name: "Bitfrost",
    link: "",
    image: require("@/assets/pic/bitfrost.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: false,
  },
  {
    key: "3",
    paraId: 1,
    name: "Bitfrost",
    link: "",
    image: require("@/assets/pic/bitfrost.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: false,
  },
  {
    key: "4",
    paraId: 1,
    name: "Bitfrost",
    link: "",
    image: require("@/assets/pic/bitfrost.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: false,
  },
  {
    key: "5",
    paraId: 1,
    name: "Bitfrost",
    link: "",
    image: require("@/assets/pic/bitfrost.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: false,
  },
  {
    key: "6",
    paraId: 1,
    name: "Bitfrost",
    link: "",
    image: require("@/assets/pic/bitfrost.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: false,
  },
  {
    key: "7",
    paraId: 1,
    name: "Bitfrost",
    link: "",
    image: require("@/assets/pic/bitfrost.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: false,
  },
  {
    key: "8",
    paraId: 1,
    name: "Bitfrost",
    link: "",
    image: require("@/assets/pic/bitfrost.png"),
    percent: 17.8,
    amount: 16579000,
    cap: 79579000,
    endBlock: 0,
    endMillisecondsLeft: 0,
    remaining: 0,
    tokens: "cDOT-6/13",
    isContribute: false,
  },
];
